module.exports = __webpack_public_path__ + "a1a01a94a0843c25d84980246ceda39b.svg";